module.exports = __webpack_public_path__ + "static/quiz_thumbnail_8-01ef1b3e0bfeaaaba3415cc7decca099.jpg";